import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import { Calendar } from 'react-date-range';
import { formatDate } from '../../helpers/utils';
import DateComponentWrapper from './DateComponentWrapper';
var DatePickerComponent = function (_a) {
    var title = _a.title, _b = _a.dateDisplayFormat, dateDisplayFormat = _b === void 0 ? 'yyyy-MM-dd' : _b, onChange = _a.onChange, defaultValue = _a.defaultValue, onUpdateValue = _a.onUpdateValue, value = _a.value, _c = _a.datePickerProps, _d = _c === void 0 ? {} : _c, datePickerOnChange = _d.onChange, datePickerProps = __rest(_d, ["onChange"]), props = __rest(_a, ["title", "dateDisplayFormat", "onChange", "defaultValue", "onUpdateValue", "value", "datePickerProps"]);
    var updateDate = function (date) {
        onChange && onChange(date);
        onUpdateValue && onUpdateValue(date);
        datePickerOnChange === null || datePickerOnChange === void 0 ? void 0 : datePickerOnChange(date);
    };
    var date = useMemo(function () {
        if (value) {
            return "".concat(formatDate(value));
        }
        else if (defaultValue) {
            return "".concat(formatDate(defaultValue));
        }
        else {
            return '-';
        }
    }, [value, defaultValue]);
    return (React.createElement(DateComponentWrapper, __assign({ value: date }, { title: title }, props),
        React.createElement(Calendar, __assign({ editableDateInputs: true, date: value, onChange: updateDate }, { dateDisplayFormat: dateDisplayFormat }, datePickerProps))));
};
export default DatePickerComponent;
//# sourceMappingURL=DatePickerComponent.js.map